import * as d3 from "d3";
import moment from "moment";

const today = moment().format("MM/DD/YYYY");
const lastYear = moment().format("MM/DD/2020");

const neighborhoodTimeline = (neighborhood, svgKey) => {
  const dates = neighborhood.map((d) => d.dateofincident);

  if (!dates.includes("01/01/2021")) {
    neighborhood.push({
      gsx$dateofincident: {
        $t: "01/01/2021",
      },
      stopgap: true,
    });
  }
  if (!dates.includes(today)) {
    neighborhood.push({
      gsx$dateofincident: {
        $t: today,
      },
      stopgap: true,
    });
  }
  if (!dates.includes("01/01/2020")) {
    neighborhood.push({
      gsx$dateofincident: {
        $t: "01/01/2020",
      },
      stopgap: true,
    });
  }
  if (!dates.includes(lastYear)) {
    neighborhood.push({
      gsx$dateofincident: {
        $t: lastYear,
      },
      stopgap: true,
    });
  }
  d3.select(`#${svgKey} svg svg`).remove();

  const parse_time = d3.timeParse("%m/%d/%Y"),
    margin = { top: 5, right: 10, bottom: 10, left: 10 },
    width = 500 - margin.left - margin.right,
    height = 300 - margin.top - margin.bottom;

  const y = d3.scaleLinear().range([height, 0]).domain([0, 25]),
    x_2021 = d3
      .scaleTime()
      .range([0, width])
      .domain([parse_time(`01/01/2021`), parse_time(today)]),
    x_2020 = d3
      .scaleTime()
      .range([0, width])
      .domain([parse_time(`01/01/2020`), parse_time(lastYear)]);

  neighborhood.sort((a, b) =>
    parse_time(a.dateofincident) < parse_time(b.dateofincident) ? -1 : 1
  );

  let cumulative_2020 = 0;
  const line_2020 = d3
    .line()
    .curve(d3.curveStepBefore)
    .x((d) => x_2020(parse_time(d.dateofincident)))
    .y((d) => {
      if (!d.stopgap) {
        cumulative_2020++;
      }
      return y(cumulative_2020);
    });

  let cumulative_2021 = 0;
  const line_2021 = d3
    .line()
    .curve(d3.curveStepBefore)
    .x((d) => x_2021(parse_time(d.dateofincident)))
    .y((d) => {
      if (!d.stopgap) {
        cumulative_2021++;
      }
      return y(cumulative_2021);
    });

  const svg = d3
    .select(`#${svgKey} .container`)
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  const chart = svg.append("g").attr("class", "chart");

  chart
    .append("path")
    .datum(
      neighborhood.filter(
        (d) =>
          d3.timeFormat("%Y")(parse_time(d.dateofincident)) === "2020" &&
          parse_time(d.dateofincident) <= parse_time(lastYear)
      )
    )
    .attr("stroke", "gray")
    .attr("stroke-width", 4)
    .attr("fill", "none")
    .attr("d", (d) => line_2020(d));

  chart
    .append("path")
    .datum(
      neighborhood.filter(
        (d) => d3.timeFormat("%Y")(parse_time(d.dateofincident)) === "2021"
      )
    )
    .attr("stroke", "red")
    .attr("stroke-width", 4)
    .attr("fill", "none")
    .attr("d", (d) => line_2021(d));
};

export default neighborhoodTimeline;
